(function () {
    'use strict';

    angular
        .module('app')
        .controller('SystemSettingListCtrl', SystemSettingListCtrl);

    /**
     * @ngdoc controller
     * @name SystemSettingListCtrl
     *
     * @description
     * List screen for 'Other' system settings.
     */

    SystemSettingListCtrl.$inject = [
        '$location',
        '$q',
        'SystemService',
        'SystemSettingsService',
        'DialogService',
        'NavigationAidService',
        'ChilliUserProfileService',
        'WindowTitleService'];

    function SystemSettingListCtrl(
        $location,
        $q,
        SystemService,
        SystemSettingsService,
        DialogService,
        NavigationAidService,
        ChilliUserProfileService,
        WindowTitleService) {

        var vm = this;
        vm.systemSettingCount = 0;
        vm.currentPage = 1;
        vm.deleteSystemSetting = deleteSystemSetting;
        vm.newSystemSetting = newSystemSetting;
        vm.close = close;
        vm.updateList = updateList;
        vm.loadingGrid = false;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.error = null;

        activate();

        /**
         * Initialises the system setting list.
         * A watch is set on the currentPage variable, when this is changed the list will be updated.
         */
        function activate() {
            WindowTitleService.setTitle('System Settings - Other');

            ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: loadEverything,
                onUserIsNotAdmin: function () { vm.permissionDenied = true; },
                onError: function (response) { DialogService.error('Error loading User profile', response); },
                onFinally: function () { vm.loading = false; }
            });

            function loadEverything() {
                return SystemService.getMenuListSize('System Settings')
                    .then(getListPageSizeOk, getListPageSizeError);
            }

            function getListPageSizeOk(data) {
                vm.listPageSize = data;

                updateList();
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        /**
         * Refreshes the system setting list.
         */
        function updateList() {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            vm.loadingGrid = true;

            var getPromise = SystemSettingsService.query({
                currentPage: vm.currentPage,
                pageSize: vm.listPageSize
            })
                .then(getSystemSettingsOk, getSystemSettingsError)
                .then(function () {
                    vm.loadingGrid = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getSystemSettingsOk(data) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = null;
                    vm.systemSettings = data.SystemSettings;
                    vm.systemSettingCount = data.SystemSettingCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getSystemSettingsError(response) {
                if (getPromise === updateList.currentPromise) {
                    vm.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /**
         * Redirect to the create system setting view.
         */
        function newSystemSetting() {
            $location.url('/system/setting/other/new');
        }

        /**
         * Deletes the system setting with the corresponding id and then refreshes the list.
         */
        function deleteSystemSetting(systemSettingId) {
            DialogService.confirm('Delete the selected System Setting?', 'System Setting delete confirm').then(deleteOk);

            function deleteOk() {
                SystemSettingsService.remove(systemSettingId)
                    .then(deleteSystemSettingOk, deleteSystemSettingError);

                function deleteSystemSettingOk(success) {
                    updateList();
                }

                function deleteSystemSettingError(response) {
                    DialogService.error('Error deleting System Setting', response);
                }
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();